// const React = require("react")
require("@fontsource/nunito")
require("@fontsource/open-sans")
require("@fontsource/inconsolata")

// const { WrapPageElement } = require("./src")

// exports.wrapPageElement = ({ element }) => <WrapPageElement element={element} />
